export const GET_DECISION = 'GET_DECISION';
export const GET_DECISION_SUCCESS = 'GET_DECISION_SUCCESS';
export const GET_DECISION_FAIL = 'GET_DECISION_FAIL';
export const GET_DECISIONS_LIST = 'GET_DECISIONS_LIST';
export const GET_DECISIONS_LIST_SUCCESS = 'GET_DECISIONS_LIST_SUCCESS';
export const GET_DECISIONS_LIST_FAIL = 'GET_DECISIONS_LIST_FAIL';
export const SET_HOLD_ON = 'SET_HOLD_ON';
export const SET_HOLD_ON_SUCCESS = 'SET_HOLD_ON_SUCCESS';
export const SET_HOLD_ON_FAIL = 'SET_HOLD_ON_FAIL';
export const SAVE_DECISION = 'SAVE_DECISION';
export const SAVE_DECISION_SUCCESS = 'SAVE_DECISION_SUCCESS';
export const SAVE_DECISION_FAIL = 'SAVE_DECISION_FAIL';
export const DECLINE_DECISION = 'DECLINE_DECISION';
export const DECLINE_DECISION_SUCCESS = 'DECLINE_DECISION_SUCCESS';
export const DECLINE_DECISION_FAIL = 'DECLINE_DECISION_FAIL';
export const ACCEPT_DECISION = 'ACCEPT_DECISION';
export const ACCEPT_DECISION_SUCCESS = 'ACCEPT_DECISION_SUCCESS';
export const ACCEPT_DECISION_FAIL = 'ACCEPT_DECISION_FAIL';
